// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2rghV","ranges":"BmiRanges_ranges__1zkzg"};